import { buildDetachedLauncherUrl } from '@/logic/game-shell/shell-bridge';
import { useStore } from '@/store/store';
import { GAME_PLAY_PATH_PREFIX } from '@/utils/url/game-play-path';
import { GAME_WINDOW_PLAY_PATH_PREFIX, isGameWindowPlayPath } from '@/utils/url/game-window-play-path';

export type EmbeddedDetachPayload = {
    transferId: string;
    launcherUrl?: string;
    popupAlreadyOpened?: boolean;
};

export const closeEmbeddedLauncher = (): void => {
    useStore.getState().embeddedGame.close();
};

export const requestEmbeddedDetach = ({
    transferId,
    launcherUrl,
    popupAlreadyOpened = false
}: EmbeddedDetachPayload): void => {
    if (!popupAlreadyOpened) {
        const { embeddedGame } = useStore.getState();
        const sourceLauncherUrl = launcherUrl ?? embeddedGame.launcherUrl ?? undefined;
        let pathPrefix = GAME_PLAY_PATH_PREFIX;
        if (sourceLauncherUrl) {
            try {
                const { pathname } = new URL(sourceLauncherUrl, window.location.origin);
                if (isGameWindowPlayPath(pathname)) {
                    pathPrefix = GAME_WINDOW_PLAY_PATH_PREFIX;
                }
            } catch {
                // Keep the legacy prefix; buildDetachedLauncherUrl handles invalid source URLs.
            }
        }

        const detachedUrl = buildDetachedLauncherUrl(transferId, sourceLauncherUrl, pathPrefix);
        const popup = window.open(detachedUrl, `fd-detached-${transferId}`, 'width=1400,height=900');

        if (!popup) {
            return;
        }

        useStore.getState().addGameWindow(popup);
    }

    closeEmbeddedLauncher();

    useStore.getState().embeddedGame.beginDetach(transferId);
    window.location.reload();
};

export const reloadEmbeddedLauncher = (): void => {
    useStore.getState().embeddedGame.iframeRef?.contentWindow?.location.reload();
};
